import { useAppInfiniteQuery } from '@libs/data-access/queries'
import type {
  UseAppInfiniteQueryOptions,
  UseAppQueryOptions,
  SubordinateType
} from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import type {
  FetchPaginatedSubordinateOptions,
  FetchSubordinateOptions,
  GetPaginatedSubordinates
} from '../membership.subordinate.api'
import {
  fetchSubordinates,
  fetchPaginatedSubordinates
} from '../membership.subordinate.api'
import { membershipSubordinateCacheKeys } from '../membership.subordinate.cacheKeys'

export const useFetchPaginatedSubordinates = (
  request: FetchPaginatedSubordinateOptions,
  queryOptions?: UseAppInfiniteQueryOptions<GetPaginatedSubordinates>
) => {
  return useAppInfiniteQuery(
    membershipSubordinateCacheKeys.paginated_subordinates(request.pathParams),
    ({ pageParam }) => fetchPaginatedSubordinates(request, Number(pageParam)),
    queryOptions
  )
}

export const useFetchSubordinates = (
  request: FetchSubordinateOptions,
  queryOptions?: UseAppQueryOptions<
    Pick<
      SubordinateType,
      'contract_id' | 'firstname' | 'lastname' | 'location_id'
    >[]
  >
) => {
  return useQuery({
    ...queryOptions,
    queryKey: membershipSubordinateCacheKeys.subordinates(request.pathParams),
    queryFn: () => fetchSubordinates(request)
  })
}
